import "./style.scss";
import gsap from "gsap";

/* structure : 
<div class="cursor-container" data-cursor-default="{opacity:0}">
    ...
    <div class="cursor">...</div>
</div>
*/

if ( document.querySelector('.cursor-container')) {
	document.querySelectorAll('.cursor-container').forEach(function(container) {
		const cursor = container.querySelector('.cursor')
		const defaultPostion =  {
			x : container.getBoundingClientRect().width - 100,
			y : container.getBoundingClientRect().height - 100
		}
		const useDefaultPosition =  container.dataset.cursorDefault == 'position';
		
		gsap.set(cursor, {
			scale:useDefaultPosition?1:0,
			opacity:useDefaultPosition?1:0,
			x: defaultPostion.x,
			y: defaultPostion.y
		});
		function startCursor(e) {
			if (!useDefaultPosition) {
				gsap.set(cursor, {
					x: e.clientX - container.getBoundingClientRect().left,
					y: e.clientY - container.getBoundingClientRect().top,
				});
				gsap.to(cursor, { scale:1,opacity:1 })
			}
		}
		function moveCursor(e) {
			gsap.to(cursor, {
				x: e.clientX - container.getBoundingClientRect().left,
				y: e.clientY - container.getBoundingClientRect().top,
				duration:0.3
			});
		}
		function resetCursor() {
			if (useDefaultPosition) {
				gsap.to(cursor, {
					x: defaultPostion.x,
					y: defaultPostion.y
				});
			} else {
				gsap.to(cursor, {
					opacity:0,
					scale:0
				});
			}
		}
		container.addEventListener('mouseenter', startCursor);
		container.addEventListener('mousemove', moveCursor);
		container.addEventListener('mouseleave', resetCursor);
	})
}
